import type { Offer } from '../domain/types';

// Incoming driver offers during SEARCH_DRIVER. The rider accepts one to assign
// the driver (POST .../accept-offer); dismissing hides it and POSTs reject-offer.
// Mirrors flutter_client driver_offers_widget.dart, minus auto-select/wallet.
export function OffersList({
  offers,
  acceptingOfferId,
  currency,
  onAccept,
  onDismiss,
}: {
  offers: Offer[];
  acceptingOfferId: string | null;
  currency: string;
  onAccept: (offerId: string) => void;
  onDismiss: (offerId: string) => void;
}) {
  if (offers.length === 0) return null;
  return (
    <div className="offers-list">
      {offers.map((offer) => {
        const accepting = acceptingOfferId === offer.id;
        const name = offer.driverName?.trim() || 'Водій';
        const rating = offer.driverRating != null ? offer.driverRating.toFixed(1) : null;
        const carLabel = [offer.carColorName, offer.carName].filter(Boolean).join(' ').trim();
        const photo = offer.driverPhoto?.trim() || null;
        return (
          <div className="offer-card" key={offer.id}>
            <div
              className="offer-card__avatar"
              style={photo ? { backgroundImage: `url(${photo})` } : undefined}
              aria-hidden="true"
            >
              {!photo && <span>{name.charAt(0).toUpperCase()}</span>}
            </div>
            <div className="offer-card__info">
              <div className="offer-card__name-row">
                <strong>{name}</strong>
                {rating && <span className="offer-card__rating">★ {rating}</span>}
              </div>
              {carLabel && <span className="offer-card__car">{carLabel}</span>}
            </div>
            <div className="offer-card__actions">
              <span className="offer-card__price">{Math.round(offer.price)} {currency}</span>
              <button
                className="offer-card__accept"
                disabled={!!acceptingOfferId}
                onClick={() => onAccept(offer.id)}
              >
                {accepting ? 'Приймаємо…' : 'Прийняти'}
              </button>
              <button
                className="offer-card__dismiss"
                disabled={!!acceptingOfferId}
                onClick={() => onDismiss(offer.id)}
                aria-label="Відхилити пропозицію"
              >
                ✕
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
